import SvgIcon, { SvgIconProps } from '../components/SvgIcon';

interface Props extends SvgIconProps {}

const TimerIcon = ({ ...props }: Props) => {
  return (
    <SvgIcon width={72} height={72} viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M54 6L53.97 24L42 36L53.97 48.03L54 66H18V48L30 36L18 24.03V6H54ZM24 49.5V60H48V49.5L36 37.5L24 49.5Z"
        fill="#008563"
      />
    </SvgIcon>
  );
};

export default TimerIcon;
